import styled from 'styled-components';

export const Footer = styled.div`
  width: 100%;
  margin: 20px 20px 5px 20px;
  height: 60px; 
  text-align: left;
`;
